<template>
  <v-form v-model="isValid">
    <p class="subtitle2">{{ $t('organization.enabled_domains') }}</p>
    <v-row v-for="(domain, index) in domains" :key="index">
      <v-col cols="11">
        <v-text-field
          outlined
          dense
          class="pa-0 ma-0 mt-3"
          v-model="domains[index]"
          :id="`domain-${index}`"
          :testId="`domainsSelector-domain-input-${index}`"
          :rules="[d => domainRules(d)]"
          :label="`${$t('organization.enter_a_domain')}*`"
          :placeholder="$t('organization.enter_a_domain_with_no_spaces')"
        >
        </v-text-field>
      </v-col>

      <v-col cols="1">
        <v-icon
          class="grey--text icon mt-5"
          :data-testid="`domainsSelector-remove-domain-${index}`"
          @click="removeDomain(index)"
        >
          mdi-delete-outline
        </v-icon>
      </v-col>
    </v-row>

    <Button
      plain
      color="primary"
      data-testid="domainsSelector-button-addAnother"
      :disabled="!isValid"
      :text="addText"
      @click="addDomain"
    />
  </v-form>
</template>

<script>
import Button from '@/components/UI/Button'
export default {
  name: 'DomainsSelector',

  props: {
    domains: {
      type: Array,
      required: false,
    },
  },

  components: {
    Button,
  },

  data() {
    return {
      isValid: true,
    }
  },

  computed: {
    addText() {
      return this.domains.length >= 1
        ? this.$t('organization.add_another')
        : this.$t('organization_settings.add_domain')
    },
  },
  methods: {
    domainRules(d) {
      const validityError = this.checkDomainValidity(d)
      const duplicityError = this.checkDomainDuplicated(d)
      const hasWWW = this.checkDomainWWW(d)
      const blackListError = this.checkBlackist(d)

      if (!d) return this.$t('validation.form.this_field_is_required')
      return validityError || duplicityError || hasWWW || blackListError || true
    },

    checkDomainValidity(d) {
      return /(?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]\.)+[a-zA-Z]{2,63}$)/.test(
        d
      )
        ? null
        : this.$t('organization.domain_is_not_valid')
    },

    checkBlackist(d) {
      return !this.$constants.organization.domainsBlacklist.includes(d)
        ? null
        : this.$t('organization.domain_is_insecure_to_add', {
            domainName: d,
          })
    },

    checkDomainWWW(d) {
      return !d?.includes('www') ? null : this.$t('organization.domain_has_www')
    },

    addDomain() {
      this.$emit('onAddDomain')
    },

    removeDomain(index) {
      this.$emit('onRemoveDomain', index)
    },

    checkDomainDuplicated(d) {
      return new Set(this.domains).size === this.domains.length
        ? null
        : this.$t('organization.domain_is_duplicated', {
            domainName: d,
          })
    },
  },
}
</script>
